import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/storeitems`;

// CREATE =>  POST: add a new product to the server
export function createStoreItem(storeItem) {
    return axios.post(API_URL, { ...storeItem });
}

// READ
export function getAllStoreItems() {
    return axios.get(API_URL);
}

export function getPaginatedStoreItems(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getStoreItemById(storeItemId) {
    return axios.get(`${API_URL}/${storeItemId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the storeItem on the server
export function updateStoreItem(storeItemId, storeItem) {
    return axios.put(`${API_URL}/${storeItemId}`, { ...storeItem });
}


// DELETE => delete the product from the server
export function deleteStoreItem(storeItemId) {
    return axios.delete(`${API_URL}/${storeItemId}`);
}
